import ProductAuthorForm from "./product-author-form";

export default ProductAuthorForm;